export default function getCompanyCheckoutParams(businessCode, companys) {
  const { gstRate, rounding } = companys?.find((company) => company?.codes?.includes(businessCode)) || {};
  return {
    ...(gstRate && !isNaN(gstRate) && { gstRate: parseFloat(gstRate) }),
    ...(rounding && { rounding }),
  };
}
